<template>

  <div class="eco-amaps-component" id="order-process-wrap">

    <div class="content-with-sidebar-component" ref="documentContainer">

      <div class="container">

        <div class="row">

          <!-- Body -->
          <div class="col-8 body">

            <div class="row p-0">
              <div class="col-12 text-center">
                <div class="progress-bar-component">
                  <router-link :to="{ name: 'Business Contract Hire Personal Details', params: { quoteId: this.$route.params.quoteId } }" class="router-link-active">
                    Employee<br>Details
                  </router-link>

                  <a v-if="!stepOneAgreed" href="#" @click="()=>{return false;}">Vehicle<br>Details</a>
                  <router-link v-else :to="{ name: 'Business Contract Hire Product Details', params: { quoteId: this.$route.params.quoteId } }"
                    class="router-link-active">
                    Vehicle<br>Details
                  </router-link>

                  <a v-if="!stepTwoAgreed" href="#" @click="()=>{return false;}">Service &amp;<br>Additional Details</a>
                  <router-link v-else
                    :to="{ name: 'Business Contract Hire Order Details', params: { quoteId: this.$route.params.quoteId } }"
                    class="router-link-active">
                    Service &amp;<br>Additional Details
                  </router-link>
                </div>

              </div>
            </div>

            <div>
              <h2 class="title">{{ heading }}</h2>
            </div>

            <div>
              <transition name="fade" mode="out-in">
                <router-view
                  v-if="currentProduct"
                  :session="session"
                  :cashAllowance="cashAllowance"
                  :confirmations="confirmations"
                  :optionSelections="optionSelections"
                  :contact="contact"
                  :derivative="derivative"
                  :driver-grade="driverGrade"
                  :driverProfile="session.driverProfile"
                  :orderType="orderType"
                  :quote="quote"
                  :orderSummaryView="true"
                  :adminPortalData="adminPortalData"
                  :sectionOneHeading="sectionOneHeading"
                  :sectionTwoHeading="sectionTwoHeading"
                  :sectionThreeHeading="sectionThreeHeading"
                  :currentProduct="currentProduct"
                >
                </router-view>
              </transition>
            </div>

            <footer-text v-if="footerText" :footerText="footerText"/>

          </div>

          <!-- Sidebar -->
          <div class="col-4 sidebar">
            <bch-cost-summary
              v-if="adminPortalData"
              :type="orderType"
              :currentProduct="currentProduct"
              :quote="quote"
              :confirmations="confirmations"
              :driverProfile="session.driverProfile"
              :adminPortalData="adminPortalData"
            />
          </div>

        </div>
      </div>
    </div>
  </div>


</template>
<script>
import {EventBus} from '@/event-bus.js';
import FooterText from "../../footer/footer-text";
import BchCostSummary from "./cost-summary";

export default {
  name: 'bch-order-process-component',
  components: {BchCostSummary, FooterText},
  props: [
    'adminPortalData',
    'session'
  ],

  beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.fetchQuote();
      EventBus.$emit('fetchData', ['driverprofile', 'drivergrades']);
    })
  },

  mounted() {
    switch (this.$router.currentRoute.name) {
      case "Business Contract Hire Personal Details":
        break;
      case "Business Contract Hire Product Details":
        if (!this.stepOneAgreed) {
          this.$router.push({name: 'Business Contract Hire Personal Details'});
          return false;
        }
        break;
      case "Business Contract Hire Order Details":
        if (!this.stepOneAgreed || !this.stepTwoAgreed) {
          this.$router.push({name: 'Business Contract Hire Personal Details'});
          return false;
        }
        break;
    }
    EventBus.$on('setConfirmations', (confirmations) => {
      this.confirmations = confirmations;
    });
  },

  data: () => {
    return {
      orderType: 'BCH',
      confirmations: {
        employeeDetails: false,
        correctVehicle: false,
      },
      optionSelections: {},
      cashAllowance: null,
      contact: null,
      derivative: null,
      driverGrade: null,
      driverProfile: null,
      quote: null,
      policesAllAccepted: false,
    }
  },

  watch: {
    confirmations: {
      handler(newVal, oldVal) {
        let complete = true;
        try {
          if (Array.isArray(this.currentProduct.order_stage_three_policies))
            this.currentProduct.order_stage_three_policies.forEach(e => {
              if (e.declaration_required === '1') {
                if (!this.confirmations[e.title] || this.confirmations[e.title] === false) {
                  complete = false;
                  throw "Non confirmed declaration found"
                }
              }
            });
        } catch (e) {
        }

        this.policesAllAccepted = complete;
      },
      deep: true
    },
    currentProduct(currentProduct) {
      currentProduct.order_stage_three_policies.forEach(e => {
        if (e.declaration_required === '1') {
          let key = e.title.replace(/\ /g, '_');
          this.$set(this.confirmations, key, false);
        }
      });
      if (currentProduct.order_stage_extra_options) {
        currentProduct.order_stage_extra_options.forEach((option => {
          this.$set(this.optionSelections, option.title, option.option_default === '1' ? true : false);
        }));
      }
    },
    session(value) {
      if (value.driverProfile) {
        this.driverProfile = value.driverProfile;
        this.contact = value.driverProfile.contacts[0];
        this.driverGrade = value.driverProfile.driverGrades['bch'].grades[this.quote.definition.driverGradeID];
        this.cashAllowance = value.driverProfile.currentCashAllowances.totalAnnualCurrentAllowance;

        this.driverProfile.fullName = value.driverProfile.contacts[0].fullName;
        this.driverProfile.emailAddress = value.driverProfile.contacts[0].emailAddress;
        this.driverProfile.mobile = value.driverProfile.contacts[0].mobile;

        this.driverProfile.companyCarGrade = this.driverGrade.name;
        this.driverProfile.privateCarGrade = this.driverGrade.name;
        this.driverProfile.totalAnnualMileage = Number(value.driverProfile.annualBusinessDistance) + Number(value.driverProfile.annualPrivateDistance);
        this.driverProfile.businessAnnualMileage = Number(value.driverProfile.annualBusinessDistance);
        this.driverProfile.privateAnnualMileage = Number(value.driverProfile.annualPrivateDistance);
        this.driverProfile.companyCarMileageReimbursementMethod = value.driverProfile.homeElectricityReimbursementName_CompanyCar;
        this.driverProfile.privateCarMileageReimbursementMethod = value.driverProfile.homeElectricityReimbursementName_PrivateCar;

        this.cashAllowance = value.driverProfile.currentCashAllowances.totalAnnualCurrentAllowance;

        if (this.adminPortalData.content.products.bch[0].order_stage_two_trade_up_trade_down_description) {
          this.confirmations.tradeUpTradeDownAgreed = false;
        } else {
          this.confirmations.tradeUpTradeDownAgreed = true;
        }
      }
    },
    stepOneAgreed(value) {
      this.$emit('stepOneAgreed', value);
    },
    stepTwoAgreed(value) {
      this.$emit('stepTwoAgreed', value);
    },
    stepThreeAgreed(value) {
      this.$emit('stepThreeAgreed', value);
    },
    tradeUpTradeDownAgreed(value) {
      this.$emit('tradeUpTradeDownAgreed', value)
    },
    $route(to, from) {
      this.scrollToTop();
    }
  },

  computed: {
    quoteExpired() {
      return new Date(this.quote?.details?.quoteExpiryDate) < new Date();
    },
    currentQuote() {
      if (!this.quote.taxCalculations) {
        return false;
      }
      return this.quote.taxCalculations.calculationResults.slice(-1)[0];
    },
    currentProduct() {
      return this.adminPortalData.content?.products?.bch[0] ? this.adminPortalData.content.products.bch[0] : false;
    },
    heading() {
      if (!this.adminPortalData.content) return '';
      return this.adminPortalData.content.products.bch[0].order_stage_one_heading;
    },
    sectionOneHeading() {
      return this.adminPortalData.content ? this.adminPortalData.content.products.bch[0].order_stage_one_section_one_title : '';
    },
    sectionTwoHeading() {
      return this.adminPortalData.content ? this.adminPortalData.content.products.bch[0].order_stage_two_section_two_title : '';
    },
    sectionThreeHeading() {
      return this.adminPortalData.content ? this.adminPortalData.content.products.bch[0].order_stage_three_section_three_title : '';
    },
    stepOneAgreed() {
      return (this.confirmations.employeeDetails);
    },
    stepTwoAgreed() {
      return (this.confirmations.correctVehicle);
    },
    tradeUpTradeDownAgreed() {
      return (this.confirmations.tradeUpTradeDownAgreed);
    },
    stepThreeAgreed() {
      return this.policesAllAccepted;
    },
    footerText() {
      return this.adminPortalData.content?.products?.bch
      && this.adminPortalData.content?.products?.bch[0]?.fca_requirement_and_content_fca_description_required
      && this.adminPortalData.content?.products?.bch[0]?.fca_requirement_and_content_fca_description
      && this.adminPortalData.content?.products?.bch[0]?.fca_description_required_on_order_process
        ? this.adminPortalData.content.products.bch[0].fca_requirement_and_content_fca_description
        : false;
    },
  },

  methods: {
    getMonthlyCost(value) {
      return (Number(value) / this.quote.term).toFixed(2);
    },
    scrollToTop() {
      this.$nextTick(() => {
        this.$refs.documentContainer.scrollTop = 0;
      });
    },

    /**
     * Get the quote
     * @returns {Promise<void>}
     */
    async fetchQuote() {
      EventBus.$emit('loading', true);

      try {
        // Moved to it's own endpoint to save the faffing
        const response = await this.$http.post('/api/quote/' + this.$route.params.quoteId);
        this.quote = response.data;

        if (this.quoteExpired) {
          Vue.notify({
            group: 'notify',
            type: 'error',
            title: 'Error',
            text: "This quote has expired. Please refresh the quote, or select another vehicle."
          });

          this.$router.push({name: 'Car Comparison'});
        }

      } catch (err) {
        let response = err.response.data;

        this.$notify({
          group: 'notify',
          type: 'error',
          title: 'Error',
          text: response.message
        });
      }

      EventBus.$emit('loading', false);
    }
  }
}
</script>
